// Pendiente de revisar
import { ItiBaseDto } from "@/iti-core-react/dtos/iti-base-dto";

export class FileTypeDto extends ItiBaseDto {
	public name: string;

	constructor(src?: any) {
		super(src);
		Object.assign(this, src);
	}
}
